import React, { useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import PageBanner from './PageBanner';
import FeaturedProducts from '../FeaturedProducts';

const FeatureGridSection = styled.section`
  padding: 1rem 2rem 3rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.5rem;
`;

const FeatureCard = styled(motion.div)`
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 2rem 1.5rem;
  text-align: center;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border: 3px solid #6bcf7f;

  .icon {
    font-size: 2.8rem;
    margin-bottom: 0.8rem;
  }

  h3 {
    color: #6bcf7f;
    margin: 0 0 0.5rem 0;
    font-size: 1.4rem;
  }

  .status {
    display: inline-block;
    background: #e8f8ec;
    color: #2e7d32;
    padding: 0.2rem 0.8rem;
    border-radius: 12px;
    font-size: 0.85rem;
    font-weight: bold;
    margin-bottom: 1rem;
  }

  p {
    color: #555;
    font-size: 0.95rem;
    line-height: 1.5;
    margin: 0;
  }
`;

const PlayArcadeBanner = styled.div`
  max-width: 900px;
  margin: 2rem auto;
  background: linear-gradient(135deg, #6bcf7f 0%, #ffd93d 100%);
  border-radius: 24px;
  padding: 2.5rem 2rem;
  text-align: center;
  color: #333;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);

  h2 {
    font-size: 2rem;
    margin: 0 0 0.8rem 0;
  }

  p {
    font-size: 1.15rem;
    max-width: 650px;
    margin: 0 auto 1.5rem auto;
  }

  button {
    background: #ff6b6b;
    color: white;
    border: none;
    padding: 1rem 2.5rem;
    border-radius: 30px;
    font-weight: bold;
    font-size: 1.2rem;
    cursor: pointer;
    box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4);
    transition: transform 0.2s;

    &:hover {
      transform: scale(1.05);
    }
  }
`;

const apps = [
  {
    icon: '📦',
    title: 'Chikin Box',
    status: 'In Development',
    desc: 'The central hub for managing your digital flock, rewards, and egg tokens.'
  },
  {
    icon: '🕹️',
    title: 'Fowl Play Arcade',
    status: 'Beta Available Now!',
    desc: 'Retro-inspired mini games including the Egg Catcher and Cluck Invaders.'
  },
  {
    icon: '🔮',
    title: 'Chikin Tarot Reader',
    status: 'Coming Soon',
    desc: 'Mystical poultry fortunes and daily egg divination readings.'
  },
  {
    icon: '🚀',
    title: 'Lunar Lander',
    status: 'In Development',
    desc: 'Help the bravest hen land safely on the moon without breaking her eggs!'
  }
];

const AppstorePage = ({ onGameOpen }) => {
  useEffect(() => {
    document.title = 'Chikin Lady Appstore - Coming Soon | Games & Web Apps';
  }, []);

  return (
    <>
      <PageBanner
        badge="🚀 Digital Experience Hub"
        title="Chikin Lady Appstore"
        subtitle="We are hatching something amazing! The Chikin Lady Appstore is your destination for fun web games, digital collectibles, and poultry entertainment."
        primaryText="🎮 Play Arcade Game"
        onPrimaryClick={onGameOpen}
        secondaryText="🏠 Back to Home"
        secondaryLink="/"
      />

      <PlayArcadeBanner>
        <h2>🕹️ Want to Play Right Now?</h2>
        <p>Our Fowl Play Arcade is currently in live preview! Catch dropping eggs, set high scores, and enjoy cluckin' awesome arcade action.</p>
        <button onClick={onGameOpen}>Launch Egg Catcher Game</button>
      </PlayArcadeBanner>

      <FeatureGridSection>
        <FeatureGrid>
          {apps.map((a, idx) => (
            <FeatureCard
              key={idx}
              whileHover={{ y: -5, scale: 1.02 }}
              transition={{ duration: 0.2 }}
            >
              <div className="icon">{a.icon}</div>
              <h3>{a.title}</h3>
              <span className="status">{a.status}</span>
              <p>{a.desc}</p>
            </FeatureCard>
          ))}
        </FeatureGrid>
      </FeatureGridSection>

      <FeaturedProducts />
    </>
  );
};

export default AppstorePage;
